import { Component, OnInit } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { scrollToTop } from '@gallaghercp/core-frontend';
import { tap, throwError } from 'rxjs';
import { LoginComponent } from '../login/login.component';
import { catchError } from 'rxjs/operators';

@Component({
    selector: 'core-register',
    templateUrl: './register.component.html',
    standalone: false,
})
export class RegisterComponent extends LoginComponent implements OnInit {
    submitting: boolean = false;
    readonly validPasswordPattern = new RegExp(
        '(?=.*?\\\d)(?=.*?[a-zA-Z])(?=.*?[-!$%^&*()_+|={}\\\\[\\\]:;' + "'" + '<>?,./€£@"~±`])(?=.*[A-Z]).{10,30}$',
    );
    registerForm = new UntypedFormGroup({
        uuid: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
        confirmEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
        password: new UntypedFormControl('', [
            Validators.required,
            Validators.minLength(10),
            Validators.pattern(this.validPasswordPattern),
        ]),
        confirmPassword: new UntypedFormControl('', [
            Validators.required,
            Validators.minLength(10),
            Validators.pattern(this.validPasswordPattern),
        ]),
        dob: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
    });

    register() {
        this.submitting = true;
        this.errorMessage = false;
        this.spinner.show('register');

        const data = {
            username: this.registerForm.get('email')!.value,
            confirmEmail: this.registerForm.get('confirmEmail')!.value,
            password: this.registerForm.get('password')!.value,
            confirmPassword: this.registerForm.get('confirmPassword')!.value,
            uuid: this.registerForm.get('uuid')!.value,
            dateOfBirth: this.registerForm.get('dob')!.value,
            data: {
                dateOfBirth: this.registerForm.get('dob')!.value,
            },
        };

        return this.subscriptions.push(
            this.api
                .post('register', data)
                .pipe(
                    tap(() => {
                        scrollToTop(500);
                        this.spinner.hide('register');
                        this.submitting = false;
                        this.successMessage = `Your account has been registered.
            To activate it, follow the instructions sent to the email address you selected`;
                        this.registerForm.reset();
                    }),
                    catchError(error => {
                        scrollToTop(500);
                        this.spinner.hide('register');
                        this.submitting = false;
                        this.errorMessage = `<p>Your registration attempt failed, please check the information you entered and try again.</p>
                                    <p>Error reference: ${error.headers.get('x-service-request-id')}</small></p>`;
                        return throwError(() => `Error Code: ${error.status}\nMessage: ${error.message}`);
                    }),
                )
                .subscribe(),
        );
    }

    override ngOnInit() {
        super.ngOnInit();

        this.titleService.setTitle('Register - ' + this.appName);

        this.auth.validateAuthentication().subscribe(() => {
            if (this.auth.isAuthenticated()) {
                return this.router.navigate(['/']);
            }
            this.auth.initialise().subscribe(() => {
                this.client.getAccessType().subscribe((type: any) => {
                    this.loginType = type;
                    if (this.loginType === 'public' && this.router.url === '/login') {
                        this.router.navigate(['/']);
                    }
                });
            });
            return false;
        });
    }
}
